import React from 'react';
import { useShoppingList } from '../deals/shoppinglistcontext';
import './shoppinglist.css';

function ShoppingList() {
    const { shoppingList, removeFromList, increaseQuantity, decreaseQuantity } = useShoppingList();

    // Shopping list helper functions
    const calculateTotalCost = () => {
        const total = shoppingList.reduce((total, item) => {
            // Extract numeric value from price, handle comma as decimal separator
            let priceStr = item.price?.replace(/\s*kr\s*/g, '') || '0'; // Remove 'kr' and spaces
            priceStr = priceStr.replace(',', '.'); // Replace comma with dot for decimal
            const numericPrice = parseFloat(priceStr || 0);
            const quantity = item.quantity || 1;
            return total + (numericPrice * quantity);
        }, 0);
        return total;
    };

    const getUniqueStores = () => {
        const stores = shoppingList.map(item => item.store).filter(store => store);
        return [...new Set(stores)];
    };

    const handleAddToNotes = () => {
        // TODO: Implement notes functionality
        alert('Add to notes functionality will be implemented soon!');
    };

    return (
        <div className="shopping-list-page">
            <div className="shopping-list-container">
                <div className="shopping-list-header">
                    <h1>🛒 Shopping List</h1>
                </div>
                
                <div className="shopping-list-content">
                    {shoppingList.length > 0 ? (
                        <>
                            <div className="shopping-items">
                                {shoppingList.map(item => (
                                    <div key={item.id} className="shopping-item">
                                        <div className="item-controls">
                                            <button
                                                className="remove-item-btn"
                                                onClick={() => removeFromList(item.id)}
                                                title="Remove entirely from shopping list"
                                            >
                                                ×
                                            </button>
                                            <div className="quantity-line">
                                                <button
                                                    className="quantity-btn"
                                                    onClick={() => decreaseQuantity(item.id)}
                                                    title="Decrease quantity"
                                                >
                                                    −
                                                </button>
                                                <span className="quantity-display">{item.quantity || 1}</span>
                                                <button
                                                    className="quantity-btn"
                                                    onClick={() => increaseQuantity(item.id)}
                                                    title="Increase quantity"
                                                >
                                                    +
                                                </button>
                                            </div>
                                        </div>
                                        <div className="item-info">
                                            <h4 className="item-product-name">{item.product}</h4>
                                            <div className="item-details">
                                                <span className="item-brand-size">
                                                    {item.brand && item.brand}
                                                    {item.brand && item.size && ' '}
                                                    {item.size && item.size}
                                                </span>
                                            </div>
                                            <p className="item-store">from {item.store}</p>
                                        </div>
                                        <div className="item-pricing">
                                            <span className="item-price">{item.price}</span>
                                            {item.originalPrice && (
                                                <span className="item-jfr-price">{item.originalPrice}</span>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            
                            <div className="shopping-summary">
                                <div className="summary-row">
                                    <span>Total Cost:</span>
                                    <span className="summary-value">
                                        {calculateTotalCost().toFixed(2).replace('.', ',')} kr
                                    </span>
                                </div>
                                <div className="summary-row">
                                    <span>Total Items:</span>
                                    <span className="summary-value">{shoppingList.length}</span>
                                </div>
                                <div className="summary-row">
                                    <span>Stores:</span>
                                    <span className="summary-value">{getUniqueStores().length}</span>
                                </div>
                                <div className="summary-stores">
                                    {getUniqueStores().map(store => (
                                        <span key={store} className="store-tag">{store}</span>
                                    ))}
                                </div>
                                
                                <button 
                                    className="add-to-notes-btn"
                                    onClick={handleAddToNotes}
                                >
                                    Add to Notes
                                </button>
                            </div>
                        </>
                    ) : (
                        <div className="empty-shopping-list">
                            <p>Your shopping list is empty</p>
                            <p>Add items by clicking "Add to List" on any deal</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ShoppingList; 